import { put } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';

import { CardPosition, Notifications, WaitingNextCardResponse } from 'types';
import { setNextCardPositionToStore } from 'data/reducers';

export function* waitingNextCard({
  type: notificationType,
  data: result,
}: WaitingNextCardResponse) {
  try {
    if (notificationType === Notifications.WAITING_NEXT_CARD) {
      yield put(setNextCardPositionToStore(result.position.toString() as CardPosition));
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}
